import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus, Info } from 'lucide-react';
import { SAMPLE, usd, pct } from '../sampleData';
import { ScoreGauge } from './ScoreGauge';
import { SectionHead } from './SectionHead';
import { OutlookDetails } from './OutlookDetails';

const DIR_ICON = { up: ArrowUpRight, down: ArrowDownRight, flat: Minus };
const DRIVERS = [
  { label: 'RSI (14)', value: SAMPLE.rsi.toFixed(1), note: 'Positive momentum', dir: 'up' },
  { label: '20-day change', value: pct(SAMPLE.roc20), note: 'Price higher than a month ago', dir: 'up' },
  { label: 'Price vs EMA 50', value: pct(SAMPLE.vsEma50), note: 'Trading above the trend line', dir: 'up' },
  { label: 'MACD', value: 'Bullish crossover', note: 'Signal line crossed upward', dir: 'up' },
  { label: 'Relative volume (5d/20d)', value: `${SAMPLE.relVol.toFixed(2)}x`, note: 'Above-average participation', dir: 'flat' },
];

const Drivers = () => (
  <div className="mk-out-block">
    <h3>Key drivers</h3>
    <ul className="mk-drivers">
      {DRIVERS.map((d) => {
        const Icon = DIR_ICON[d.dir];
        return (
          <li key={d.label}>
            <span className={`mk-dir ${d.dir}`}><Icon size={14} aria-hidden="true" /><span className="sr-only">{d.dir === 'up' ? 'supports bullish' : 'neutral'}</span></span>
            <span className="mk-drv-label">{d.label}<small>{d.note}</small></span>
            <span className="mk-num mk-drv-val">{d.value}</span>
          </li>
        );
      })}
    </ul>
  </div>
);

export const SampleOutlook = () => (
  <section className="mk-section mk-alt" id="sample-outlook" aria-labelledby="sample-title">
    <div className="mk-container">
      <SectionHead id="sample-title" eyebrow="Sample output" title="What an AI outlook looks like" sub="Every outlook in the app has the same structure: the number, what drives it, where it is wrong, and what could change it." />
      <article className="mk-card mk-outlook" data-testid="sample-outlook-card">
        <p className="mk-sample-flag" data-testid="sample-outlook-label"><Info size={14} aria-hidden="true" /> Sample for illustration only. Fictional ticker, not a real signal.</p>
        <header className="mk-out-head">
          <div>
            <p className="mk-out-ticker">{SAMPLE.ticker} <small>{SAMPLE.name}</small></p>
            <p className="mk-out-meta">Horizon: {SAMPLE.horizon} · Strategy: {SAMPLE.strategy}</p>
          </div>
          <div className="mk-out-score">
            <ScoreGauge score={SAMPLE.score} label="Score" />
            <p className="mk-dir up mk-out-dir"><ArrowUpRight size={16} aria-hidden="true" /> {SAMPLE.direction}</p>
          </div>
        </header>
        <div className="mk-prob" data-testid="sample-probability">
          <span className="mk-num mk-prob-val">{SAMPLE.probability}%</span>
          <span>Probability of closing above {usd(SAMPLE.entry)} within 1 week <small>Estimated from 60-day drift and 20-day volatility of daily returns.</small></span>
        </div>
        <div className="mk-out-grid">
          <Drivers />
          <OutlookDetails />
        </div>
      </article>
    </div>
  </section>
);
